<template>
  <div class="editInformation">
    <van-form
      label-width="120px"
      :show-error="false"
      :scroll-to-error="false"
      @failed="onFailed"
      @submit="onSubmit"
    >
      <div class="title">{{ $t.enterpriseInfo.companyInfo }}</div>
      <van-field
        :label="$t.enterpriseInfo.companyLogo"
        :name="$t.enterpriseInfo.companyLogo"
        required
        :rules="formRule"
      >
        <template #input>
          <van-uploader
            v-model="companyLogoPic"
            :max-count="1"
            :after-read="afterRead1"
          />
        </template>
      </van-field>
      <van-field
        :label="$t.enterpriseInfo.licence"
        :name="$t.enterpriseInfo.licence"
        required
        :rules="formRule"
      >
        <template #input>
          <van-uploader
            v-model="businessLicence"
            :max-count="1"
            :after-read="afterRead2"
          />
        </template>
      </van-field>
      <van-field :label="$t.enterpriseInfo.officialSeal">
        <template #input>
          <van-uploader
            v-model="officialSealPic"
            :max-count="1"
            :after-read="afterRead3"
          />
        </template>
      </van-field>
      <van-field
        v-model="form.CompanyName"
        :label="$t.enterpriseInfo.companyName"
        :name="$t.enterpriseInfo.companyName"
        :placeholder="$t.information.input"
        type="textarea"
        rows="5"
        required
        :rules="formRule"
      />
      <van-field
        v-model="CompanyCode"
        :label="$t.enterpriseInfo.companyCode"
        label-class="number-label"
        readonly
      >
        <template #button>
          <van-button
            size="small"
            type="info"
            @click="onCopy(CompanyCode)"
            native-type="button"
            >{{ $t.meta.copy }}</van-button
          >
        </template>
      </van-field>
      <van-field
        v-model="form.CompanyProfileCn"
        :label="$t.enterpriseInfo.companyProfileCN"
        :placeholder="$t.information.input"
        type="textarea"
        rows="5"
      />
      <van-field
        v-model="form.CompanyProfileEn"
        :label="$t.enterpriseInfo.companyProfileEN"
        :placeholder="$t.information.input"
        type="textarea"
        rows="5"
      />
      <van-field
        v-model="form.LegalPersonName"
        :label="$t.enterpriseInfo.legal"
        :name="$t.enterpriseInfo.legal"
        :placeholder="$t.information.input"
        required
        :rules="formRule"
      />
      <van-field
        v-model="form.CreditCode"
        :label="$t.enterpriseInfo.creditCode"
        :name="$t.enterpriseInfo.creditCode"
        :placeholder="$t.information.input"
        required
        :rules="formRule"
      />
      <van-field
        v-model="form.DetailAddress"
        :label="$t.enterpriseInfo.creditCode"
        :placeholder="$t.information.detailAddress"
        type="textarea"
        rows="5"
      />
      <div class="tool-bar" v-if="!disabled">
        <van-button round block type="info" native-type="submit">{{
          $t.enterpriseInfo.submit
        }}</van-button>
      </div>
    </van-form>
  </div>
</template>
<script>
import Vue from "vue";
import { Form, Field, Button, Uploader, Icon } from "vant";
import { mapMutations } from "vuex";
import { SET_AUTH } from "@/store/mutation-types";

Vue.use(Form).use(Field).use(Button).use(Uploader).use(Icon);

export default {
  name: "editInformation",
  data() {
    return {
      CompanyCode: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyCode,
      form: {},
      formRule: [
        {
          required: true,
          message: this.$t.meta.require,
        },
      ],
      companyLogoPic: [],
      businessLicence: [],
      officialSealPic: [],
      disabled: true,
    };
  },
  created() {
    this.getUserInfo();
  },
  methods: {
    ...mapMutations([SET_AUTH]),
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    getUserInfo() {
      this.$commonMethod.showLoading();
      var param = {
        UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      };
      this.$api.myHome
        .getUserInfo(param)
        .then((res) => {
          this.form = res.data;
          if (this.form.CompanyAddUserId == this.form.UserId) {
            this.disabled = false;
          } else {
            this.disabled = true;
          }
          if (this.form.CompanyLogoPic) {
            this.companyLogoPic.push({
              url: this.imgUrlFilter(this.form.CompanyLogoPic),
            });
          }
          if (this.form.BusinessLicence) {
            this.businessLicence.push({
              url: this.imgUrlFilter(this.form.BusinessLicence),
            });
          }
          if (this.form.OfficialSealPic) {
            this.officialSealPic.push({
              url: this.imgUrlFilter(this.form.OfficialSealPic),
            });
          }
          this.SET_AUTH(res.data);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    onSubmit() {
      this.$commonMethod.showLoading();
      var param = this.form;
      this.$api.myHome
        .editCompanyInfo(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    onFailed(errorInfo) {
      if (errorInfo && errorInfo.errors.length > 0) {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
          msg: errorInfo.errors[0].name + " " + errorInfo.errors[0].message,
        });
      }
    },
    afterRead1(file) {
      this.$commonMethod.showLoading();
      var formData = new FormData();
      formData.append("file", file.file);
      this.$api.system
        .uploadImgFile(formData)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.meta.uploadSuccess,
            type: "success",
          });
          this.form.CompanyLogoPic = res.data;
          this.$commonMethod.hideLoading();
        })
        .catch(() => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: this.$t.meta.uploadFail,
          });
        });
    },
    afterRead2(file) {
      this.$commonMethod.showLoading();
      var formData = new FormData();
      formData.append("file", file.file);
      this.$api.system
        .uploadImgFile(formData)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.meta.uploadSuccess,
            type: "success",
          });
          this.form.BusinessLicence = res.data;
          this.$commonMethod.hideLoading();
        })
        .catch(() => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: this.$t.meta.uploadFail,
          });
        });
    },
    afterRead3(file) {
      this.$commonMethod.showLoading();
      var formData = new FormData();
      formData.append("file", file.file);
      this.$api.system
        .uploadImgFile(formData)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.meta.uploadSuccess,
            type: "success",
          });
          this.form.OfficialSealPic = res.data;
          this.$commonMethod.hideLoading();
        })
        .catch(() => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: this.$t.meta.uploadFail,
          });
        });
    },
    onCopy(text) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.clickCopy, {
        text: text,
        alertText: this.$t.meta.copySuccess,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.editInformation {
  ::v-deep .number-label {
    line-height: 33px;
  }
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
  .avatarImg {
    width: 50px;
    height: 50px;
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .van-button {
      border-radius: 0px;
    }
  }
}
</style>
